export default __webpack_public_path__ + "static/media/YounesBenbouchta.211c058d.png";